module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v("Ian Bradley is Emeritus Professor of Cultural and Spiritual History at the University of St Andrews. Among his many books are "), _c('em', [_vm._v("Pilgrimage: A Cultural and Spiritual Journey")]), _vm._v(" (2009), "), _c('em', [_vm._v("Argyll: The Making of a Spiritual Landscape")]), _vm._v(" (St Andrew Press, 2015), "), _c('em', [_vm._v("Following the Celtic Way")]), _vm._v(" (Darton, Longman & Todd, 2018) and "), _c('em', [_vm._v("The Fife Pilgrim Way")]), _vm._v(" (Birlinn, 2019).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("The Coffin Roads: Journeys to the West")]), _vm._v(" is the second in a trilogy of books on aspects of death and the afterlife. The first, "), _c('em', [_vm._v("The Quiet Haven: An Anthology of Readings on Death and Heaven")]), _vm._v(", was published in 2021 by Darton, Longman & Todd and the third, "), _c('em', [_vm._v("Breathers of an Ampler Air: Heaven and the Victorians")]), _vm._v(", is due to be published by the Sacristy Press in 2024.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 57
// module chunks = 0